import { render } from "./Permission.vue?vue&type=template&id=3f65a640&scoped=true&ts=true"
import script from "./Permission.vue?vue&type=script&lang=s'ts"
export * from "./Permission.vue?vue&type=script&lang=s'ts"

import "./Permission.vue?vue&type=style&index=0&id=3f65a640&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f65a640"]])

export default __exports__